import React from 'react';
import styled from 'styled-components';
import {
  screenXsMax,
  spacer16,
  spacer40,
  Type,
} from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';
import { Box } from '../../ui';
import { FAQItem, Variant } from './FAQItem';
import type { SearchHit } from '../../Search/types';

const HelpFAQComponent = styled(Box)``;

const Headline = styled(Type.h1).attrs({
  paddingBottom: '0.75em',
  variant: 'alto',
  weight: 'bold',
})<{}>`
  padding-top: ${spacer16};
  padding-bottom: ${spacer40};
`;

const FAQWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-content: flex-start;
  width: 100%;

  @media (max-width: ${screenXsMax}) {
    flex-flow: column;
  }
`;

export type HelpFAQType = {
  headline?: string;
  items?: SearchHit[];
};

export const HelpFAQ: React.FC<HelpFAQType> = ({ headline, items = [] }) => {
  const t = useT();

  return (
    (items?.length && (
      <HelpFAQComponent data-testid="help-faq">
        <Headline>
          {headline ||
            t(
              'FRODOR_HELP_FAQ_TOP_ARTICLES',
              'Top help articles',
              'Headline for the top help articles section',
            )}
        </Headline>
        <FAQWrapper>
          {items?.length &&
            items.map(
              (item, key) =>
                item && (
                  <React.Fragment key={key}>
                    <FAQItem hit={item} variant={Variant.SPEED_DIAL} />
                  </React.Fragment>
                ),
            )}
        </FAQWrapper>
      </HelpFAQComponent>
    )) || <></>
  );
};
